import { render, staticRenderFns } from "./orderHandlerModal.vue?vue&type=template&id=f07b3466&"
import script from "./orderHandlerModal.vue?vue&type=script&lang=js&"
export * from "./orderHandlerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports